module.exports = __webpack_public_path__ + "img/icon_map_0_off_101.25986cbb.png";